<template>
  <svg
    width="62"
    height="62"
    viewBox="0 0 62 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_4283)">
      <g clip-path="url(#clip1_1_4283)">
        <mask
          id="mask0_1_4283"
          style="mask-type: luminance"
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="80"
          height="60"
        >
          <path d="M81 1H1V61H81V1Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1_4283)">
          <mask
            id="mask1_1_4283"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="1"
            y="1"
            width="80"
            height="60"
          >
            <path d="M1 1H81V61H1V1Z" fill="white" />
          </mask>
          <g mask="url(#mask1_1_4283)">
            <path d="M1 1H81V61H1V1Z" fill="#CC0000" />
            <path d="M1 1H81V5.2875H1V1Z" fill="#CC0000" />
            <path d="M1 5.28906H81V9.57656H1V5.28906Z" fill="white" />
            <path d="M1 9.57422H81V13.8617H1V9.57422Z" fill="#CC0000" />
            <path d="M1 13.8633H81V18.1258H1V13.8633Z" fill="white" />
            <path d="M1 18.1367H81V22.4242H1V18.1367Z" fill="#CC0000" />
            <path d="M1 22.4258H81V26.7133H1V22.4258Z" fill="white" />
            <path d="M1 26.7109H81V30.9984H1V26.7109Z" fill="#CC0000" />
            <path d="M1 31H81V35.2875H1V31Z" fill="white" />
            <path d="M1 35.2891H81V39.5766H1V35.2891Z" fill="#CC0000" />
            <path d="M1 39.5742H81V43.8617H1V39.5742Z" fill="white" />
            <path d="M1 43.8633H81V48.1258H1V43.8633Z" fill="#CC0000" />
            <path d="M1 48.1367H81V52.4242H1V48.1367Z" fill="white" />
            <path d="M1 52.4258H81V56.7133H1V52.4258Z" fill="#CC0000" />
            <path d="M1 56.7109H81V60.9984H1V56.7109Z" fill="white" />
            <path d="M1 1.0625H41V35.35H1V1.0625Z" fill="#000066" />
            <path
              d="M26.9367 10.2256L27.6867 15.3131L30.5617 11.0631L29.0117 15.9631L33.4492 13.3631L29.9367 17.1131L35.0617 16.7131L30.2742 18.5631L35.0617 20.4131L29.9367 20.0131L33.4492 23.7631L29.0117 21.1631L30.5492 26.0756L27.6742 21.8131L26.9242 26.9006L26.1867 21.8131L23.3117 26.0631L24.8617 21.1631L20.4242 23.7631L23.9242 20.0131L18.7992 20.4131L23.5992 18.5631L18.8117 16.7131L23.9367 17.1131L20.4242 13.3631L24.8617 15.9631L23.3117 11.0506L26.1867 15.3131L26.9367 10.2256ZM22.7742 10.4381C21.4207 9.83595 19.9381 9.58168 18.4613 9.69844C16.9845 9.81519 15.5602 10.2993 14.3181 11.1066C13.076 11.914 12.0555 13.019 11.3492 14.3213C10.643 15.6235 10.2734 17.0817 10.2742 18.5631C10.2734 20.0445 10.643 21.5027 11.3492 22.8049C12.0555 24.1072 13.076 25.2122 14.3181 26.0196C15.5602 26.8269 16.9845 27.311 18.4613 27.4278C19.9381 27.5445 21.4207 27.2903 22.7742 26.6881C21.2798 27.7616 19.5182 28.4019 17.6832 28.5387C15.8483 28.6754 14.0112 28.3032 12.3742 27.4631C10.7391 26.6218 9.36757 25.346 8.41048 23.7758C7.45338 22.2056 6.94777 20.402 6.94922 18.5631C6.94983 16.7247 7.45721 14.922 8.41561 13.3532C9.37401 11.7844 10.7463 10.5101 12.3818 9.67043C14.0172 8.83075 15.8525 8.45815 17.6859 8.59358C19.5193 8.72901 21.2799 9.36723 22.7742 10.4381Z"
              fill="#FFCC00"
            />
          </g>
        </g>
      </g>
    </g>
    <rect x="0.5" y="0.5" width="61" height="61" rx="30.5" stroke="#DEE2E4" />
    <defs>
      <clipPath id="clip0_1_4283">
        <rect x="1" y="1" width="60" height="60" rx="30" fill="white" />
      </clipPath>
      <clipPath id="clip1_1_4283">
        <rect width="80" height="60" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
</template>
